export default ({ palette, typography }) => ({
  callToAction: {
    color: palette.secondary,
    fontFamily: typography.fontFamilies.primary,
    fontSize: 24,
    fontWeight: typography.fontWeights.medium,
  },
  tab: {
    color: palette.secondary,
    fontFamily: typography.fontFamilies.primary,
    fontSize: 24,
    fontWeight: typography.fontWeights.medium,
    textAlign: 'center',
  },
  tabActive: {
    border: `1px solid ${palette.text}`,
    color: palette.text,
  },
});
